import useNotificationHandler from "hooks/useNotificationHandler";
import { MUTATION_KEYS } from "library/shared";
import { IBenefitCategory } from "library/types";
import { useMutation } from "react-query";
import api from "service/api";
import { useInvalidateBenefitCategories } from "./useGetBenefitCategories";

type Params = {
  countryCode: number | string;
  clientInternalNumberGOS: number | string;
  payload: IBenefitCategory;
};

const createBenefitCategory = async ({
  countryCode,
  clientInternalNumberGOS,
  payload,
}: Params) => {
  const response = await api.post(
    `/benefitcategory/${countryCode}/${clientInternalNumberGOS}`,
    payload
  );

  return response.data as IBenefitCategory;
};

export function useCreateBenefitCategory(refetch = true) {
  const { handleAddAxiosErrorNotification } = useNotificationHandler();
  const invalidateBenefitCategories = useInvalidateBenefitCategories();
  return useMutation(createBenefitCategory, {
    mutationKey: MUTATION_KEYS.createBenefitCategory,
    onSuccess: () => {
      if (refetch) {
        invalidateBenefitCategories();
      }
    },
    onError: (error) => {
      // handle error
      handleAddAxiosErrorNotification(error);
    },
  });
}
